module.exports = __webpack_public_path__ + "static/media/Shabnam-Bold.1cfd106d.ttf";